import React from "react";
import {
  handlePlayerReady,
  playpause,
  hideplayIcon,
  share,
} from "../../utils/Helper";
import VideoPlayer from "../../common/VideoPlayer";

const VideoCard = ({ video, handleShareData, type, sharetext }) => {
  return (
    <>
      <div className="videocard_pad">
        <div className="videocard_bg">
          <div className="videocard_thumb">
            {/* <img src={video.thumb_url} className="videothumban" alt="" /> */}
            <div className="video_tab">
              {video && (
                <VideoPlayer
                  onReady={handlePlayerReady}
                  id={video.id}
                  keyi={video.id}
                  key={video.id}
                  video_url={video.video_url}
                  thumb={video.image_url}
                  type={type}
                />
              )}
              <span
                className="play_layer"
                onClick={() => {
                  playpause(video.id, type);
                }}
                onMouseMove={() => {
                  hideplayIcon(video.id, type);
                }}
              >
                <img
                  src="/assets/images/playvideoppc.svg"
                  className={"play_icon playpausebtn_" + video.id}
                  alt=""
                />
              </span>
              <span
                className="main_play"
                onClick={() => {
                  playpause(video.id, type);
                }}
              ></span>
            </div>

            {/* <div className="video_overlay"></div>
            <button className="videothumplay">
              <img src="/assets/images/playvideoppc.svg" alt="" />
            </button> */}
          </div>
          <div className="videocard_content">
            <h4>{video.title}</h4>
            {/* <h4>Artists Edition - Building Focus & Memory During Exams</h4> */}
            <ul className="ppc_watch_now ppc_watch_pad_video">
              <li className="ppc_watch_pad">
                <button
                  className="ppc_watc_btn"
                  onClick={() => playpause(video.id, type)}
                >
                  <img src="/assets/images/playchange.svg" alt="" /> Watch Now
                </button>
              </li>
              <li>
                <button
                  className="ppc_share_btn"
                  onClick={() => {
                    const shareUrl = `https://www.narendramodi.in/parikshapecharcha2025/${video.episode_id}/video/${video.id}`;

                    share(video.id, sharetext, "youtube", shareUrl);
                    handleShareData(shareUrl, sharetext, sharetext, "youtube");
                  }}
                >
                  <img src="/assets/images/shareorange.svg" alt="" />
                  Share
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoCard;
